export default [
  {
    title: 'Data Management',
    customIcon: 'DataManageSVG',
    children: [
      {
        title: 'Customer',
        route: 'custom-module',
        path: '/custom-module/dataManagement',
      },
    ],
  },
];
